import React, { useEffect, useState } from 'react'
import { Media, MediaProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import * as modelProps from 'models/media/media-property-definitions';
import utils from 'features/media/media-util'
import validations from 'features/media/media-validation'

export interface MediaProps {
    BuildList?: (page: any, name: MediaProperties, form: Media) => JSX.Element[]
    page?: any
    title?: any
    form?: Media
    onUpdate?: (form: Media, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function MediaForm(props: MediaProps) {
    let [form, setForm] = useState({} as Media)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as Media)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as Media)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<Media, MediaProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.MediaProperties.Id,
                modelProps.MediaProperties.Deleted,
                modelProps.MediaProperties.Version,
                modelProps.MediaProperties.Created,
                modelProps.MediaProperties.Updated,
                modelProps.MediaProperties.Owner,
                modelProps.MediaProperties.Description,
                modelProps.MediaProperties.HasProcessed,
                modelProps.MediaProperties.IsPrivate,
                modelProps.MediaProperties.Likes,
                modelProps.MediaProperties.MediaDuration,
                modelProps.MediaProperties.MediaInformation,
                modelProps.MediaProperties.ThumbnailDefaultUrl,
                modelProps.MediaProperties.ThumbnailLocation,
                modelProps.MediaProperties.MediaPreviewLocation,
                modelProps.MediaProperties.Restrictions,
                modelProps.MediaProperties.MediaType,
                modelProps.MediaProperties.MediaStatus,
                modelProps.MediaProperties.Name,
                modelProps.MediaProperties.Thumbnails,
                modelProps.MediaProperties.Released,
                modelProps.MediaProperties.Profile,
                modelProps.MediaProperties.MediaReactions,
                modelProps.MediaProperties.Tag,
                modelProps.MediaProperties.MediaRelLocation,
                modelProps.MediaProperties.TransparentTitleUrl,
                modelProps.MediaProperties.TransparentTitleLocation,
            ].includes(x.name))
        },
        BuildList: (page, name: MediaProperties, form: Media) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        DropdownOptions: (page, propertyName, form) => {
            return utils.DropdownOptions(propertyName)
        },
        setForm: (
            form: Media,
            property: MediaProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: MediaProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>{BuildForm<Media, MediaProperties>(args)}</React.Fragment>
    )
}
